/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { MyInjector } from "@src/app/app.module";
import { ActionColor, IFormAction } from "@src/app/shared/form/form.component";
import { PersonService } from "@src/app/pages/person-page/person.service";
import { ContactTypes, Person } from "@src/app/model/person";
import { Observable } from "rxjs";

/**
 * Replaces Delete on the agent contact screen. Agency staff are audit history - their requests,
 * actions and follows must keep resolving - so we retire them instead of removing the record.
 */
export class RetireAction implements IFormAction {
    name = $localize`Retire`;
    color: ActionColor = 'warn';
    show = false;
    icon = 'person_off';
    approvalNeeded = true;
    disabled = false;
    approvalText = $localize`This removes the contact's role so they can no longer log in, blocks any
        further email to them, and marks them as a past participant. Their requests, actions and
        history are all kept. Continue?`;
    tipText = "Remove this contact's access when they leave the agency";

    personService = MyInjector.instance.get(PersonService);

    private person: Person;

    action(): Observable<Person> {
        return this.personService.retire(this.person);
    }

    setup(item: Person) {
        this.person = item;
        this.show = item?.contactType !== ContactTypes.past;
    }
}
